import React, { Ref } from "react";

import { IFormOption } from "shared/types";

import { FieldWrapper, FieldWrapperProps } from "../FieldWrapper";
import { Radio } from "./Radio";

interface RadioGroupProps extends FieldWrapperProps {
  options: IFormOption[];
  onChange?: (value: any) => void;
  registerRef?: Ref<HTMLInputElement>;
  isInline?: boolean;
  isDisabled?: boolean;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  registerRef,
  name,
  options,
  error,
  onChange,
  isDisabled,
  isInline = true,
  ...rest
}) => (
  <FieldWrapper name={name} error={error} {...rest}>
    <div
      style={{
        display: "flex",
        flexDirection: isInline ? "row" : "column",
        gap: ".5rem",
        flexWrap: "wrap",
      }}
    >
      {options?.map((data, index) => (
        <Radio
          key={data.value}
          name={name}
          onChange={onChange}
          index={index}
          disabled={isDisabled}
          registerRef={registerRef}
          {...data}
        />
      ))}
    </div>
  </FieldWrapper>
);
